import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const PrivateRoute = ({ auth, children }) => {
	if (auth && auth.isAuthenticated === true) {
		return children;
	} else {
		return <Redirect to='/sign-in' />;
	}
};

PrivateRoute.propTypes = {
	auth: PropTypes.object.isRequired,
	children: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
